import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';
import {
  getPostLoadMetaRequest,
  getUserSettingsRequest,
  getUserSubscriptionMetadataRequest,
} from '../../../../../home/extra-actions';
import {
  resetSubscription,
  resetCalculatePayState,
  resetPurchaseLeadFinderSubscriptionRequestStatus,
  resetPurchaseLeadFinderModifySubscriptionResponse,
} from '../../billing-subscription-slice';
import {
  calculatePayRequest,
  getLeadFinderSubscriptionRequest,
  purchaseCreditsRequest,
  purchaseLeadFinderModifySubscriptionRequest,
  purchaseLeadFinderSubscriptionRequest,
  paddlePollingThunk,
} from '../../extra-actions';
import { PaddleApplicationType } from '../../types/paddle';
import {
  CalculatePayRequest,
  PurchaseModifySubscriptionRequest,
  PurchaseSubscriptionRequest,
} from '../../types';
import LeadFinderPlans from './lead-finder-plans';
import { selectPaddleCustomerId } from '../../../../../home/home-slice';

const mapStateToProps = (state: RootState) => ({
  getCouponCodeResponse: state.billingAndSubscription.applyCouponCodeResponse,
  sendGetLeadFinderSubscriptionRequestStatus:
    state.billingAndSubscription.getLeadFinderSubscriptionRequest.status,
  sendGetLeadFinderSubscriptionResponse:
    state.billingAndSubscription.getLeadFinderSubscriptionResponse,
  sendGetLeadFinderPlansResponse:
    state.billingAndSubscription.getLeadFinderPlansResponse,
  sendPurchaseLeadFinderSubscriptionRequestStatus:
    state.billingAndSubscription.purchaseLeadFinderSubscriptionRequest.status,
  sendPurchaseLeadFinderSubscriptionRequestMessage:
    state.billingAndSubscription.purchaseLeadFinderSubscriptionRequest.message,
  sendPurchaseLeadFinderModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseLeadFinderModifySubscriptionRequest
      .status,
  sendPurchaseLeadFinderModifySubscriptionRequestMessage:
    state.billingAndSubscription.purchaseLeadFinderModifySubscriptionRequest
      .message,
  sendPurchaseModifySubscriptionResponse:
    state.billingAndSubscription.purchaseModifySubscriptionResponse,
  sendGetCalculatePayRequestStatus:
    state.billingAndSubscription.calculatePayRequest.status,

  couponCodeDiscount:
    state.billingAndSubscription.applyCouponCodeResponse?.discountValue,
  couponCodeDiscountType:
    state.billingAndSubscription.applyCouponCodeResponse?.discountType,
  leadFinderSubscriptionPlanResponse: state.home.leadFinderSubscription,
  isVersionLocked: state.home.leadFinder?.isVersionLocked ?? false,

  paymentProvider: state.home?.paymentProvider,
  userId: state.home?.userId,
  shAccountId: state.home?.shAccountId,
  userEmail: state.home?.email,
  adminSettings: state.adminSettings.adminSettings,
  paddlePolling: state.billingAndSubscription.paddlePolling,
  paddleCustomerId: selectPaddleCustomerId(state),
});

const mapDispatchToProps = {
  sendGetCalculatePayRequest: (payload: CalculatePayRequest) =>
    calculatePayRequest(payload),
  sendPurchaseLeadFinderSubscriptionRequest: (
    payload: PurchaseSubscriptionRequest,
  ) => purchaseLeadFinderSubscriptionRequest(payload),
  sendPurchaseLeadFinderModifySubscriptionRequest: (
    payload: PurchaseModifySubscriptionRequest,
  ) => purchaseLeadFinderModifySubscriptionRequest(payload),
  sendGetLeadFinderSubscriptionRequest: () =>
    getLeadFinderSubscriptionRequest(),
  sendGetUserSettingsRequest: () => getUserSettingsRequest(),
  sendGetUserSubscriptionMetadataRequest: () =>
    getUserSubscriptionMetadataRequest(),
  resetSubscription: () => resetSubscription(),
  resetCalculatePayState: () => resetCalculatePayState(),
  startPaddlePollingThunk: (payload: {
    shAccountId: number;
    applicationType: PaddleApplicationType;
    planId?: number;
  }) => paddlePollingThunk(payload),
  resetPurchaseLeadFinderSubscriptionRequestStatus: () =>
    resetPurchaseLeadFinderSubscriptionRequestStatus(),
  resetPurchaseLeadFinderModifySubscriptionResponse: () =>
    resetPurchaseLeadFinderModifySubscriptionResponse(),
  sendGetPostLoadMetaRequest: () => getPostLoadMetaRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export default connector(LeadFinderPlans);
